var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 5,
    viewBox: "0 0 21 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "combo shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.41732C0 3.56791 0.93274 4.50065 2.08333 4.50065C3.23393 4.50065 4.16667 3.56791 4.16667 2.41732C4.16667 1.26672 3.23393 0.333984 2.08333 0.333984C0.93274 0.333984 0 1.26672 0 2.41732ZM10.4167 4.50065C9.26607 4.50065 8.33333 3.56791 8.33333 2.41732C8.33333 1.26672 9.26607 0.333984 10.4167 0.333984C11.5673 0.333984 12.5 1.26672 12.5 2.41732C12.5 3.56791 11.5673 4.50065 10.4167 4.50065ZM18.75 4.50065C17.5994 4.50065 16.6667 3.56791 16.6667 2.41732C16.6667 1.26672 17.5994 0.333984 18.75 0.333984C19.9006 0.333984 20.8333 1.26672 20.8333 2.41732C20.8333 3.56791 19.9006 4.50065 18.75 4.50065Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.7bceacb2db57cf7d217478876040beda.svg";
export { ForwardRef as ReactComponent };